import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as notificationsActions from 'features/notifications/duck';
import * as requestUpdateActions from 'features/request-update/duck';
import { shippingValidationRules, shippingDetailsErrorStrings } from 'shared/validations';
import { ValidationService } from 'shared/services';
import { mapEventUpdate, filterCapacityTypesByUnlimited } from './../selectors';
import { ModalInfo, SimpleModal, AlertMessage, ScrollFade } from 'shared/components';
import {
  REQUEST_UPDATE_TYPE,
  REQUEST_UPDATE_STATUS,
  LOCATION_EVENT_STATUS,
  TIMING_CATEGORIES_NAME,
} from 'shared/constants';
import {
  cloneDeep,
  find,
  findIndex,
  get,
  isEmpty,
  isEqual,
  isNull,
  omitBy,
  isUndefined,
  omit,
} from 'lodash';
import { CapacityTab, AdmissionTab, ShippingTab, Review } from 'features/request-update';
import { calculateNewTotal } from '../helpers';
import { getDefaultEventUpdate } from 'features/request-update/selectors';
import PendingIcon from 'assets/svgs/pendingIcon.svg';

import './RequestUpdateData.scss';

class RequestUpdateData extends Component {
  constructor(props) {
    super(props);
    const eventUpdate = props.eventUpdate;
    this.state = {
      activeTab: '',
      locationEvents: [],
      message: !isEmpty(eventUpdate) ? eventUpdate.message : '',
      shippingAddress: !isEmpty(eventUpdate) ? eventUpdate.shippingAddress : {},
      showConfirmModal: false,
      errorsShippingAddress: {},
      reviewModalOpen: false,
      showAlertMessage: false,
      alertMessage: '',
    };

    this.onChangeCapacity = this.onChangeCapacity.bind(this);
    this.onToggleLocation = this.onToggleLocation.bind(this);
    this.onAdmissionUpdate = this.onAdmissionUpdate.bind(this);
    this.onShippingUpdate = this.onShippingUpdate.bind(this);
    this.onReviewChanges = this.onReviewChanges.bind(this);
    this.getUpdates = this.getUpdates.bind(this);
    this.onSave = this.onSave.bind(this);
    this.toggleConfirmModal = this.toggleConfirmModal.bind(this);
    this.closeDataModal = this.closeDataModal.bind(this);
    this.closeReviewModal = this.closeReviewModal.bind(this);
    this.setTab = this.setTab.bind(this);
    this.showCloseModal = this.showCloseModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.eventUpdate, this.props.eventUpdate)) {
      this.setState({
        locationEvents: this.props.eventUpdate.locationEvents,
        message: this.props.eventUpdate.message,
        shippingAddress: this.props.eventUpdate.shippingAddress,
      });
    }
    if (
      this.props.activeTab &&
      (this.props.activeTab !== prevProps.activeTab || !this.state.activeTab)
    ) {
      this.setState({
        activeTab: this.props.activeTab,
      });
    }

    const pageHasErrors = !isEmpty(omitBy(this.state.errorsShippingAddress, isUndefined));
    Array.from(document.querySelectorAll('.nav-item-popover.disabled')).forEach((el) => {
      const popover = bootstrap.Popover.getOrCreateInstance(el);
      if (pageHasErrors) {
        popover.enable();
      } else {
        popover.disable();
      }
    });
    Array.from(document.querySelectorAll('.nav-item-popover:not(.disabled)')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).disable()
    );

    if (window.innerWidth > 800 && window.innerHeight > 600) {
      setTimeout(
        () =>
          Array.from(document.querySelectorAll('.pending-icon')).forEach((el) =>
            bootstrap.Popover.getOrCreateInstance(el).enable()
          ),
        500
      );
    } else {
      Array.from(document.querySelectorAll('.pending-icon')).forEach((el) =>
        bootstrap.Popover.getOrCreateInstance(el).enable()
      );
    }
  }

  onChangeCapacity(e, locationId, capacityTypeId, isBlur = false) {
    const value = e.target.value ? +e.target.value : null;
    const locationEvents = cloneDeep(this.state.locationEvents);
    const currentCapacityType = this.props.capacityTypes.find(
      (capType) => capType.id === capacityTypeId
    );

    const newValue =
      isBlur &&
      value > 0 &&
      value < 5 &&
      currentCapacityType.timing === TIMING_CATEGORIES_NAME.extended
        ? 5
        : value;
    let locationIndex = findIndex(locationEvents, { locationId: locationId });
    if (locationIndex !== -1) {
      let capacityIndex = findIndex(locationEvents[locationIndex].capacities, {
        capacityTypeId: capacityTypeId,
      });
      if (capacityIndex !== -1) {
        if (isNull(value)) {
          locationEvents[locationIndex].capacities.splice(capacityIndex, 1);
        } else {
          locationEvents[locationIndex].capacities[capacityIndex].capacity = newValue;
          locationEvents[locationIndex].capacities[capacityIndex].capacityValue = value;
        }
      } else if (!isNull(value)) {
        locationEvents[locationIndex].capacities.push({
          capacityTypeId: capacityTypeId,
          capacity: newValue,
          capacityValue: value,
        });
      }
    } else if (!isNull(value)) {
      locationEvents.push({
        locationId: locationId,
        status: LOCATION_EVENT_STATUS.open,
        capacities: [
          {
            capacityTypeId: capacityTypeId,
            capacity: newValue,
            capacityValue: value,
          },
        ],
      });
    }

    this.setState({
      locationEvents,
    });
  }

  onToggleLocation(locationId) {
    const { allEventLocations } = this.props;
    const locationEvents = cloneDeep(this.state.locationEvents);
    const location = find(allEventLocations, { id: locationId });

    let locationIndex = findIndex(locationEvents, { locationId: locationId });

    if (locationIndex !== -1) {
      locationEvents[locationIndex].status =
        locationEvents[locationIndex].status &&
        locationEvents[locationIndex].status.toUpperCase() === LOCATION_EVENT_STATUS.closed
          ? LOCATION_EVENT_STATUS.open
          : LOCATION_EVENT_STATUS.closed;
    } else {
      locationEvents.push({
        locationId: locationId,
        status:
          location.locationEvent.status.toUpperCase() === LOCATION_EVENT_STATUS.closed
            ? LOCATION_EVENT_STATUS.open
            : LOCATION_EVENT_STATUS.closed,
        capacities: [],
      });
    }
    this.setState({
      locationEvents,
    });
  }

  onAdmissionUpdate(value) {
    this.setState({
      message: value,
    });
  }

  onShippingUpdate(name, value, error) {
    let errors;
    if (!error) {
      errors = ValidationService.validate(
        { [name]: value },
        { [name]: shippingValidationRules[name] },
        { [name]: shippingDetailsErrorStrings[name] }
      );
    }

    this.setState((prevState) => ({
      shippingAddress: {
        ...prevState.shippingAddress,
        [name]: value,
      },
      errorsShippingAddress: {
        ...prevState.errorsShippingAddress,
        [name]: error || errors[name],
      },
    }));
  }

  onReviewChanges() {
    const { allEventLocations, capacityTypes } = this.props;

    const locationEvents = cloneDeep(this.state.locationEvents);

    locationEvents.map((location) => {
      const matchingLocation = allEventLocations.find((loc) => loc.id === location.locationId);
      const totalLocCapacityIsZero =
        calculateNewTotal([location], matchingLocation ? [matchingLocation] : [], capacityTypes) ===
        0;

      if (
        (location.status && location.status.toUpperCase() === LOCATION_EVENT_STATUS.closed) ||
        totalLocCapacityIsZero
      ) {
        location.capacities = [];
        location.status = LOCATION_EVENT_STATUS.closed;
      }

      return location;
    });

    const totalNewCapacity = calculateNewTotal(locationEvents, allEventLocations, capacityTypes);

    if (totalNewCapacity) {
      this.setState({
        reviewModalOpen: true,
        locationEvents,
      });
    } else {
      this.setState({
        showConfirmModal: true,
      });
    }
  }

  getUpdates() {
    const { allEventLocations, tcEvent, capacityTypes } = this.props;

    const { message, shippingAddress } = this.state;

    const result = {
      locationEvents: [],
      shippingAddress: {},
    };
    const defaultData = getDefaultEventUpdate(tcEvent);
    const locationEvents = cloneDeep(this.state.locationEvents);

    allEventLocations.map((location) => {
      const locationCapacities = find(locationEvents, {
        locationId: location.id,
      });
      let capacitiesUpdated = [];

      if (!isEmpty(locationCapacities)) {
        const defaultLocationStatus = location.locationEvent.status.toUpperCase();
        const totalLocCapacityIsZero =
          calculateNewTotal([locationCapacities], [location], capacityTypes) === 0;

        if (
          !locationCapacities.status ||
          (locationCapacities.status &&
            locationCapacities.status.toUpperCase() !== defaultLocationStatus) ||
          totalLocCapacityIsZero
        ) {
          if (
            (locationCapacities.status &&
              locationCapacities.status.toUpperCase() === LOCATION_EVENT_STATUS.closed) ||
            totalLocCapacityIsZero
          ) {
            locationCapacities.capacities = [];
            locationCapacities.status = LOCATION_EVENT_STATUS.closed;
          } else {
            locationCapacities.capacities.forEach((capacityObj) =>
              capacitiesUpdated.push(omit(capacityObj, ['capacityValue']))
            );
          }
          result.locationEvents.push({
            ...locationCapacities,
            capacities: capacitiesUpdated,
          });
        } else if (
          locationCapacities.status &&
          locationCapacities.status.toUpperCase() === LOCATION_EVENT_STATUS.open
        ) {
          locationCapacities.capacities.map((capacityObj) => {
            if (!isNull(capacityObj.capacity)) {
              capacitiesUpdated.push({
                capacityTypeId: capacityObj.capacityTypeId,
                capacity: capacityObj.capacity,
              });
            }
          });

          if (!isEmpty(capacitiesUpdated)) {
            result.locationEvents.push({
              locationId: location.id,
              capacities: capacitiesUpdated,
              status: locationCapacities.status,
            });
          }
        }
      }
    });

    if (message !== defaultData.message) {
      result.message = message;
    }

    for (const key in defaultData.shippingAddress) {
      //const prevValue = (!isEmpty(eventUpdate.shippingAddress) && !isUndefined(eventUpdate.shippingAddress[key]) && eventUpdate.shippingAddress[key] !== defaultData.shippingAddress[key]) ? eventUpdate.shippingAddress[key] : defaultData.shippingAddress[key];
      if (
        !isUndefined(shippingAddress[key]) &&
        shippingAddress[key] !== defaultData.shippingAddress[key]
      ) {
        result.shippingAddress[key] = shippingAddress[key];
      }
    }

    if (isEmpty(result.locationEvents)) {
      delete result.locationEvents;
    }

    if (isEmpty(result.shippingAddress)) {
      delete result.shippingAddress;
    }

    return result;
  }

  async onSave() {
    const { actions, currentRequest, tcEvent, testCenterCycle, userId } = this.props;

    const eventUpdateData = this.getUpdates();

    const data = {
      testCenterId: testCenterCycle.testCenterProgram.testCenter.id,
      testingEventId: tcEvent.testingEvent.id,
      type: 'event_update',
      data: {
        eventUpdate: eventUpdateData,
      },
    };

    if (currentRequest.id) {
      await actions.updateRequest({ ...data, id: currentRequest.id });
    } else {
      await actions.createRequest(data);
    }
    actions.getRequestUpdate(
      testCenterCycle.testCenterProgram.testCenter.id,
      tcEvent.testingEvent.id
    );
    actions.getNotViewedNotificationsCount(userId);
    this.closeReviewModal(false);
    this.setState({
      showAlertMessage: true,
      alertMessage: 'requestUpdate.review.successMessage',
    });
  }

  toggleConfirmModal() {
    this.setState((prevState) => ({
      showConfirmModal: !prevState.showConfirmModal,
    }));
  }

  closeDataModal(backToType) {
    this.setState({
      locationEvents: this.props.eventUpdate.locationEvents,
      message: this.props.eventUpdate.message,
      shippingAddress: this.props.eventUpdate.shippingAddress,
      errorsShippingAddress: {},
      activeTab: '',
    });

    this.props.toggleModal(backToType);
  }

  closeReviewModal(goBack = true) {
    this.setState({
      reviewModalOpen: false,
    });

    if (!goBack) {
      this.closeDataModal();
    }
  }

  setTab(tab, disabled, e) {
    if (!disabled) {
      this.setState({
        activeTab: tab,
      });
      e.currentTarget.scrollIntoView({
        block: 'nearest',
        inline: 'center',
        behavior: 'smooth',
      });
    }
  }

  showCloseModal() {
    this.toggleConfirmModal();
    this.closeDataModal(false);
    this.props.showCloseModal();
  }

  removeAlertMessage = () => {
    this.setState({
      showAlertMessage: false,
    });
  };

  scrollContent(e) {
    console.log(e);
  }

  render() {
    const {
      activeTab,
      locationEvents,
      message,
      reviewModalOpen,
      shippingAddress,
      showConfirmModal,
      errorsShippingAddress,
      showAlertMessage,
      alertMessage,
    } = this.state;

    const {
      currentRequest,
      dataModalOpen,
      allEventLocations,
      capacityTypes,
      tcEvent,
      testCenterCycle,
      eventLocations,
      errorUpdateRequest,
    } = this.props;

    const pageHasErrors = !isEmpty(omitBy(errorsShippingAddress, isUndefined));
    const showPending =
      !isEmpty(currentRequest) &&
      currentRequest.type === REQUEST_UPDATE_TYPE.eventUpdate &&
      (currentRequest.status === REQUEST_UPDATE_STATUS.pending ||
        currentRequest.status === REQUEST_UPDATE_STATUS.inProgress);
    const currentRequestData = get(currentRequest, 'data.eventUpdate', {});

    return (
      <>
        <ModalInfo
          containerClass="modal-update-data-container"
          className="modal-update-data"
          modalIsOpen={dataModalOpen && !showConfirmModal && !reviewModalOpen}
          closeModal={() => this.closeDataModal(false)}
          onCancel={() => this.closeDataModal(true)}
          onSubmit={this.onReviewChanges}
          headerTitle={this.props.t('requestUpdate.title')}
          saveLabel={this.props.t('requestUpdate.reviewBtnLabel')}
          cancelLabel={this.props.t('common.labels.back')}
          disabledSubmit={pageHasErrors}
          tooltipContent={this.props.t('requestUpdate.tooltipDisabledText')}
          showCancel>
          <div onScroll={this.scrollContent}>
            <ScrollFade>
              <div className="nav-tabs-container">
                <ul className="nav nav-tabs" id="requestUpdateTab" role="tablist">
                  <li className="tab-side-spacing"></li>
                  <li className={`nav-item ${activeTab === 'capacity' ? 'active' : ''}`}>
                    {showPending && (
                      <span
                        className={`request-pending-icon ${
                          isEmpty(currentRequestData.locationEvents) ? 'hidden' : ''
                        }`}
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-bs-content={this.props.t(
                          'requestUpdate.pending.capacityPendingMessage'
                        )}>
                        <PendingIcon />
                      </span>
                    )}
                    <div
                      className={`nav-item-popover ${pageHasErrors ? 'disabled' : ''}`}
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-bs-content={this.props.t('requestUpdate.tooltipDisabledText')}>
                      <a
                        className={`nav-link ${
                          activeTab === 'capacity' ? 'active' : pageHasErrors ? 'disabled' : ''
                        }`}
                        id="capacity-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        href="#capacity"
                        onClick={(e) => this.setTab('capacity', pageHasErrors, e)}
                        aria-controls="capacity">
                        {this.props.t('requestUpdate.capacityTab')}
                      </a>
                    </div>
                  </li>
                  <div className="one-px-separator"></div>
                  <li className={`nav-item ${activeTab === 'admission' ? 'active' : ''}`}>
                    {showPending && (
                      <span
                        className={`request-pending-icon ${
                          isUndefined(currentRequestData.message) ? 'hidden' : ''
                        }`}
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-bs-content={this.props.t(
                          'requestUpdate.pending.admissionPendingMessage'
                        )}>
                        <PendingIcon />
                      </span>
                    )}
                    <div
                      className={`nav-item-popover ${pageHasErrors ? 'disabled' : ''}`}
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-bs-content={this.props.t('requestUpdate.tooltipDisabledText')}>
                      <a
                        className={`nav-link ${
                          activeTab === 'admission' ? 'active' : pageHasErrors ? 'disabled' : ''
                        }`}
                        id="admission-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        href="#admission"
                        onClick={(e) => this.setTab('admission', pageHasErrors, e)}
                        aria-controls="admission">
                        {this.props.t('requestUpdate.admissionTab')}
                      </a>
                    </div>
                  </li>
                  <div className="one-px-separator"></div>
                  <li className={`nav-item ${activeTab === 'shipping' ? 'active' : ''}`}>
                    {showPending && (
                      <span
                        className={`request-pending-icon ${
                          isEmpty(currentRequestData.shippingAddress) ? 'hidden' : ''
                        }`}
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-bs-content={this.props.t(
                          'requestUpdate.pending.shippingPendingMessage'
                        )}>
                        <PendingIcon />
                      </span>
                    )}
                    <div
                      className={`nav-item-popover ${pageHasErrors ? 'disabled' : ''}`}
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-bs-content={this.props.t('requestUpdate.tooltipDisabledText')}>
                      <a
                        className={`nav-link ${
                          activeTab === 'shipping' ? 'active' : pageHasErrors ? 'disabled' : ''
                        }`}
                        id="shipping-tab"
                        data-bs-toggle="tab"
                        role="tab"
                        href="#shipping"
                        onClick={(e) => this.setTab('shipping', pageHasErrors, e)}
                        aria-controls="shipping">
                        {this.props.t('requestUpdate.shippingTab')}
                      </a>
                    </div>
                  </li>
                  <li className="tab-side-spacing"></li>
                </ul>
              </div>
            </ScrollFade>
            <div className="tab-content" id="requestUpdateTabContent">
              <div
                className={`tab-pane fade ${activeTab === 'capacity' ? 'show active' : ''}`}
                id="capacity"
                role="tabpanel"
                aria-labelledby="capacity-tab">
                <CapacityTab
                  locations={allEventLocations}
                  capacityTypes={capacityTypes}
                  locationEvents={locationEvents}
                  tcEvent={tcEvent}
                  onChange={this.onChangeCapacity}
                  onToggleLocation={this.onToggleLocation}
                />
              </div>
              <div
                className={`tab-pane fade ${activeTab === 'admission' ? 'show active' : ''}`}
                id="admission"
                role="tabpanel"
                aria-labelledby="admission-tab">
                <AdmissionTab
                  tcEvent={tcEvent}
                  testCenterName={testCenterCycle.testCenterProgram.testCenter.name}
                  eventLocation={eventLocations.length ? eventLocations[0] : {}}
                  message={message}
                  onAdmissionUpdate={this.onAdmissionUpdate}
                />
              </div>
              <div
                className={`tab-pane fade ${activeTab === 'shipping' ? 'show active' : ''}`}
                id="shipping"
                role="tabpanel"
                aria-labelledby="shipping-tab">
                <ShippingTab
                  tcEvent={tcEvent}
                  shippingAddress={shippingAddress}
                  errors={errorsShippingAddress}
                  onShippingUpdate={this.onShippingUpdate}
                />
              </div>
            </div>
          </div>
        </ModalInfo>

        <SimpleModal
          isOpen={showConfirmModal}
          icon="error_outline"
          onCancel={this.toggleConfirmModal}
          onConfirm={this.showCloseModal}
          confirmLabel={this.props.t('common.labels.yes')}
          cancelLabel={this.props.t('common.labels.no')}
          headline={this.props.t('requestUpdate.closeConfirmationModal.title')}
          message={this.props.t('requestUpdate.closeConfirmationModal.message')}
        />

        <Review
          modalOpen={reviewModalOpen}
          onSave={this.onSave}
          onClose={this.closeReviewModal}
          getUpdates={this.getUpdates}
          locations={allEventLocations}
          shippingAddress={shippingAddress}
          capacityTypes={capacityTypes}
        />

        <AlertMessage
          show={showAlertMessage}
          removeMessage={this.removeAlertMessage}
          message={errorUpdateRequest ? 'errors.somethingWentWrong' : alertMessage}
          isError={errorUpdateRequest}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    capacityTypes: filterCapacityTypesByUnlimited(state),
    tcEvent: state.tcEvent.currentEvent,
    testCenterCycle: state.tcEvent.testCenterCycle,
    allEventLocations: state.tcEvent.allEventLocations,
    eventLocations: state.tcEvent.eventLocations,
    currentRequest: state.requestUpdate.currentRequest,
    errorUpdateRequest: state.requestUpdate.errorUpdateRequest,
    eventUpdate: mapEventUpdate(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...notificationsActions, ...requestUpdateActions }, dispatch),
  };
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
  })(RequestUpdateData)
);

RequestUpdateData.propTypes = {
  tcEvent: PropTypes.shape({}).isRequired,
  testCenterCycle: PropTypes.shape({}).isRequired,
  currentRequest: PropTypes.shape({}),
  eventUpdate: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

RequestUpdateData.defaultProps = {};
